// src/pages/SuiviConservationPage.jsx
import React from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SuiviConservation } from "../components/artwork/SuiviConservation";
import IconButtons from "../components/shared/IconButtons";

const SuiviConservationPage = () => {
  const { artworkId } = useParams();
  const { t } = useTranslation();

  // Données d'exemple à remplacer par les données réelles de l'œuvre.
  const conservationData = {
    lastFullReport: t("conservationTrackingPage.values.notProvidedMasculine"),
    lastInspection: t("conservationTrackingPage.values.notProvidedFeminine"),
    lastTransport: t("conservationTrackingPage.values.notProvidedMasculine"),
    riskLevel: t("conservationTrackingPage.values.assessmentPending"),
    nextInspectionDue: t("conservationTrackingPage.values.toCalculate"),
    nextFullReportDue: t("conservationTrackingPage.values.toSchedule"),
    recommendation: t("conservationTrackingPage.values.sampleRecommendation"),
  };

  return (
    <div className="max-w-6xl mx-auto pb-16">
      <header className="flex justify-between items-center border-b border-gray-200 px-6 py-4">
        <h1 className="text-3xl title-artsy break-words whitespace-normal">
          {t("conservationTrackingPage.title")}
        </h1>
        <IconButtons
          backUrl={`/artwork/${artworkId}`}
          editUrl={`/conservation/${artworkId}/suivi/edit`}
          showDelete={false}
        />
      </header>

      <div className="p-6">
        <SuiviConservation data={conservationData} />
      </div>
    </div>
  );
};

export default SuiviConservationPage;
